import { HomeQuesTypeSelectContent } from './HomeQuesTypeSelectContent';
export default HomeQuesTypeSelectContent;